<template>
	<div class="container page">
		<van-nav-bar :title="$t('withdraw.with_center')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
			<template #right>
				<span class="nav-right"
					@click="$router.push({path:'/WithdrawRecord'})">{{$t("withdraw.with_record")}}</span>
			</template>
		</van-nav-bar>
		<div class="main">
			<div class="withdrawMoney">
				<!-- ({{$t("reservation.unit")}}) -->
				<span> {{$t("withdraw.with_money")}} </span>
				<div class="money">
					<div class="moneyNumber">

						<van-field v-model="withdraw_money" type="number" />
						
					</div>
					<span class="all" @click="allMoeny()">{{$t("withdraw.all")}}</span>
				</div>
				<div class="information">
					<div class="description">
						<van-popover v-model="showPopover" trigger="click">
							<div class="popover-body" style="padding: 10px;">
								<p>1.{{$t("withdraw.single_limit")}}{{$t("withdraw.low")}}{{this.withdrawRole.min}}{{$t("withdraw.heigh")}}{{this.withdrawRole.max}}
								</p>
								<p>2.{{$t("withdraw.with_num")}}{{this.withdrawRole.num}}{{$t("withdraw.number")}}</p>
								<p>3.{{$t("withdraw.with_tip")}}</p>
							</div>
							<template #reference @click="withdrawInfo()">
								<van-icon name="info-o" />
								{{$t("withdraw.limit_desc")}}
							</template>
						</van-popover>
					</div>

					<div class="balance">
						<span>：</span>
						<span class="number">{{ this.userInfo.money }}원</span>
					</div>
				</div>
			</div>
			<van-button class="withdraw_btn" type="default" @click="doWithdraw()">
				{{$t("withdraw.immediately_withdraw")}}</van-button>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				showPopover: false,
				withdraw_money: "",
				userInfo: {},
				withdrawRole: {}
			};
		},
		methods: {
			back() {
				return window.history.back();
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data;
						this.name = res.data.name;
						
					// 如果用户未绑定银行卡，直接跳转 BindCard
						if (!res.data.is_bank) {
							this.$router.push({ path: '/BindCard' });
							this.$toast('먼저 은행 카드를 등록해 주세요');
							return; // 直接返回，避免后续逻辑执行
						}
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			getUserWithdrawRole() {
				this.$http({
					method: 'get',
					url: 'user_get_withdraw_role'
				}).then(res => {
					if (res.code === 200) {
						this.withdrawRole = res.data;
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			allMoeny() {
				this.withdraw_money = this.userInfo.money;
			},
			doWithdraw() {
				if (this.withdraw_money <= 0) {
					this.$toast(this.$t("setting.correct_money"));
					return false;
				}
				this.$toast.loading({ duration: 0, forbidClick: true });
				this.$http({
					method: 'post',
					data: {
						money: this.withdraw_money
					},
					url: 'user_set_withdraw'
				}).then(res => {
					this.$toast.clear();
					if (!res || res.code === undefined) {
						this.$toast('서버 오류, 잠시 후 다시 시도해주세요');
						return;
					}
					if (res.code === 200) {
						this.$toast(res.msg);
						this.withdraw_money = '';
						this.getUserInfo();
						this.getUserWithdrawRole();
					} else {
						this.$toast(res.msg || '출금 실패');
					}
				}).catch(() => {
					this.$toast.clear();
					this.$toast('서버 오류, 잠시 후 다시 시도해주세요');
				});
			},
			withdrawInfo() {
				this.showPopover = true;
			}
		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				})
			} else {
				this.getUserInfo();
				this.getUserWithdrawRole();
			}
		}
	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.van-cell {
		font-size: 35px;
		line-height: 80px;
	}

	.container p {
		padding: 0 15px;
		margin-top: 15px;
		font-size: 30px;
		color: #dc2037;
	}

	.container .main {
		display: flex;
		flex-direction: column;
		background-color: #f2f2f5;
		height: calc(100% - 50px);
		position: relative;
	}

	.container .main .withdrawMoney {
		display: flex;
		flex-direction: column;
		color: #000;
		margin: 20px 20px 0;
		padding: 20px 24px;
		white-space: nowrap;
		font-size: 35px;
		background-color: #fff;
		border-radius: 18px;
		box-shadow: 0 10px 28px rgba(79, 43, 138, 0.22), 0 4px 12px rgba(0, 0, 0, 0.12);
	}

	.container .main .withdrawMoney span {
		padding: 10px 0;
	}

	.container .main .withdrawMoney .money {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		border-bottom: 1px solid #f2f2f5;
	}

	.container .main .withdrawMoney .money .moneyNumber {
		font-size: 50px;
		display: flex;
		flex-direction: row;
	}

	.container .main .withdrawMoney span {
		padding: 10px 0;
	}

	.container .main .withdrawMoney .money .all {
		color: #d10404;
	}

	.container .main .withdrawMoney .money .moneyNumber .van-cell {
		font-size: 50px;
		padding: 0 !important;
	}

	.container .main .withdrawMoney .information {
		padding-bottom: 30px;
	}

	.container .main .withdrawMoney .information .description {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding: 10px 0;
	}

	.container .main .withdrawMoney span {
		padding: 10px 0;
	}

	.container .main .withdrawMoney .information .balance .number {
		color: #d10404;
	}

	.withdraw_btn {
		margin: 24px 30px 0;
		height: 80px;
		line-height: 1.22667rem;
		border-radius: 50px;
		color: #fff;
		font-size: 30px;
		font-weight: bolder;
		border: none;
		background: linear-gradient(30deg, #7d76ef, #d63f8c);
		box-shadow: 0 10px 28px rgba(125, 118, 239, 0.35), 0 4px 12px rgba(0, 0, 0, 0.12);
	}
</style>